import React from "react"
import { useUserActionAuditTrailContext } from "contexts/UserActionAuditTrailContext"
import StrikeAround from "shared/StrikeAround"
import AuditList from "./AuditList"

const UserActionAuditTrailGroups = () => {
  const { auditGroups } = useUserActionAuditTrailContext()

  return (
    <>
      {
        Object.entries(auditGroups).map(([formattedDate, audits]) => (
          <div key={formattedDate} className="mb-8">
            <StrikeAround className="mb-9">
              <span className="font-medium text-xl" aria-hidden>{ formattedDate }</span>
            </StrikeAround>
            <AuditList audits={audits} />
          </div>
        ))
      }
    </>
  )
}

export default UserActionAuditTrailGroups
